// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"812e725b","396":"6ce67de3","447":"ffd53deb","455":"fb303c6c","819":"3552b209","967":"35274420","977":"bfe638dc"}[chunkId] + ".chunk.js";
};